import CryptoJS from 'crypto-js';

const cryptoKey = process.env.CRYPTO_KEY || "b!om#12345";

export const myFetchImplementation = (url, options) => {
    let isCrypting = false;
    let stringify = JSON.stringify;
    let parse = JSON.parse;

    const encodeTextBody = (text) => CryptoJS.AES.encrypt(text, cryptoKey);
    
    const decodeTextBody = async(text) => {
        const parsedJson = parse(text);
        if(parsedJson.errors && parsedJson.errors.length > 0) {
            return parsedJson.errors;
        }else {
            const bytes  = CryptoJS.AES.decrypt(parsedJson.data, cryptoKey);
            return parse(bytes.toString(CryptoJS.enc.Utf8));
        }
        
    }

    options = options || {};

    return new Promise(async (resolve, reject) => {
        let req = new XMLHttpRequest();
        req.open(options.method || "get", url);
        for (let i in options.headers) {
            if (isEncoding && i.toLowerCase() === "content-type") {
                req.setRequestHeader(i, "text/plain; charset=UTF-8");
                req.setRequestHeader("Content-Transfer-Encoding", "base64");
                isCrypting = true;
            } else {
                req.setRequestHeader(i, options.headers[i]);
            }
        }
        
        req.withCredentials = options.credentials === "include";
        req.onload = () => {
            let resolveReq = resolve;
            let rejectReq = reject;
            let responseFromReq = response;
            const parsedJson = response().json();

            parsedJson.then((response) => {
                const data = (JSON.parse(response).data || [])[0];
                if(data && data.message) {
                    rejectReq({code: data.extensions.code, message: data.message});
                } else {
                    resolveReq(responseFromReq());
                }
            })
        };
        req.onerror = reject;

        let body = options.body;
        req.send(isEncoding ? await encodeTextBody(body) : body);

        // Decode response

        const response = () => {
            let keys = [], all = [], headers = {}, header;

            req.getAllResponseHeaders().
                replace(/^(.*?):\s*([\s\S]*?)$/gm, (m, key, value) => {
                    keys.push((key = key.toLowerCase()));
                    all.push([key, value]);
                    header = headers[key];
                    headers[key] = header ? `${header},${value}` : value;
                });

                return {
                    ok: ((req.status / 200) | 0) == 1,
                    status: req.status,
                    statusText: req.statusText,
                    url: req.responseURL,
                    clone: response,
                    text: async () => {
                        const r =  isCrypting ? await decodeTextBody(req.responseText) : req.responseText;
                        return stringify({data:r});
                    },
                    json: async () => {
                        const r =  (isCrypting ? await decodeTextBody(req.responseText) : req.responseText);
                        return stringify({data:r});
                    },
                    blob: () => Promise.resolve(new Blob([req.response])),
                    headers: {
                      keys: () => keys,
                      entries: () => all,
                      get: n => headers[n.toLowerCase()],
                      has: n => n.toLowerCase() in headers
                    }
                  };
        }


    })
}

const shouldEncode = (url, options) => {
    // if (process.env.NODE_ENV === "development") return false;
    if (!options.method || options.method.toLowerCase() !== "post")
        return false;
    url = url.split("?")[0].split("#")[0];
    if (!url.endsWith("/graphql")) return false;
    return true;
}

const isEncoding = shouldEncode(process.env.REACT_APP_API_HOST, { method: 'post', 'Content-Type': 'application/json' });